import React, { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-apollo";

import { Fieldset, Field, Control, Button } from "rbx";

import Section from "../Section";

import { CREATE_HOLIDAY_MUTATION } from "../../graphql/Holidays/Holidays.graphql";

import { ourToast as toast } from "../../utils";

import HolidayForm from "./HolidayForm";

const INITIAL_STATE = {
  HolidayDate: "",
  HolidayDescription: ""
};

const AddHolidayForm = ({ onComplete }) => {
  const [inputs, setInputs] = useState({ ...INITIAL_STATE });
  const handleChange = e => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };
  const [createHoliday, { loading }] = useMutation(CREATE_HOLIDAY_MUTATION, {
    refetchQueries: ["ALL_HOLIDAYS_QUERY"]
  });

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      await createHoliday({
        variables: {
          data: {
            ...obj,
            HolidayDate: inputs.HolidayDate
              ? new Date(inputs.HolidayDate).setUTCHours(13)
              : ""
          }
        }
      });
      toast.success("Holiday created successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error creating Holiday.");
    }
  };
  return (
    <Section title="Add Holiday">
      <form id="add-holiday-form" onSubmit={handleSubmit}>
        <Fieldset disabled={loading}>
          <HolidayForm inputs={inputs} onChange={handleChange} />
          <hr />
          <Field kind="group">
            <Control>
              <Button color="success" form="add-holiday-form" type="submit">
                Submit
              </Button>
            </Control>
            <Control>
              <Button type="button" onClick={onComplete}>
                Cancel
              </Button>
            </Control>
          </Field>
        </Fieldset>
      </form>
    </Section>
  );
};

AddHolidayForm.propTypes = {
  onComplete: PropTypes.func
};
export default AddHolidayForm;
